module.exports = __webpack_public_path__ + "static/media/projectPic4.96fdf553.png";